<template>
  <div v-if="submission" class="modal fade show d-block" tabindex="-1" style="display: block; z-index: 1050;">
    <div class="modal-dialog" role="document" :style="modalStyle">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title">进件详情
            <span
              :class="['badge ms-2', merchantTypeLabel === '个人小微商户' ? 'bg-info' : 'bg-primary']"
              style="font-size: 0.75rem; vertical-align: middle;"
            >
              {{ merchantTypeLabel }}
            </span>
          </h5>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <!-- 商户类型提示 -->
          <div
            v-if="isIndividualMerchant"
            class="alert alert-info alert-sm mb-3 d-flex align-items-center"
            style="padding: 8px 12px; font-size: 0.8rem;"
          >
            <i class="ni ni-bell-55 me-2"></i>
            <span>
              此商户为<b>个人小微商户</b>，未提交营业执照。日流水限额5-10万，超限后需补交营业执照方可继续收款。
            </span>
          </div>
          <!-- 处理中且已要求短信授权时，显示短信授权提醒 -->
          <div
            v-if="submission.status === 'handling' && submission.feedback && submission.feedback.includes('请在手机上完成收钱吧短信授权')"
            class="alert alert-warning alert-sm mb-3"
            style="padding: 8px 12px; font-size: 0.8rem;"
          >
            <i class="ni ni-mobile-button me-2"></i>
            <span>
              请在手机上完成收钱吧短信授权，授权后请务必回来完成通知，以免延误渠道开通时间。
            </span>
          </div>
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">资料项目</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">内容</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in filteredPayInfo" :key="key">
                  <td class="text-xs font-weight-bold mb-0">{{ title[key] || key }}</td>
                  <td class="text-xs">
                    <!-- 小微商户：营业执照栏位显示"免提交" -->
                    <template v-if="key === 'business_license' && isIndividualMerchant">
                      <span class="badge bg-secondary" style="background: #e9ecef !important; color: #6c757d !important; font-weight: normal; padding: 4px 10px; border-radius: 4px;">小微商户免提交</span>
                    </template>
                    <template v-else-if="key === 'business_license' && !value">
                      <span class="text-muted">未上传</span>
                    </template>
                    <div v-if="isJson(value)">
                      <div v-for="(nestedValue, nestedKey) in value" :key="nestedKey">
                        <strong>{{ title[nestedKey] }} </strong>
                        <div v-if="isOSSFile(nestedValue)">
                          <div v-if="isImage(nestedValue)">
                            <!-- Wait until the image URL is resolved -->
                            <img v-if="ossFileUrls[nestedValue]" :src="ossFileUrls[nestedValue]" alt="file" class="img-fluid restricted-image" />
                          </div>
                          <div v-else>
                            <soft-avatar
                              :img="img1"
                              size="sm"
                              border-radius="lg"
                              class="me-3"
                              alt="user-avatar"
                            />
                            <span>{{ nestedValue }}</span>
                            <a :href="ossFileUrls[nestedValue]" download>下载文件</a>
                          </div>
                        </div>
                        <div v-else>
                          <span>{{ nestedValue }}</span>
                        </div>                        
                      </div>
                    </div>
                    <div v-else-if="isOSSFile(value)">
                      <div v-if="isImage(value)">
                        <!-- Wait until the image URL is resolved -->
                        <img v-if="ossFileUrls[value]" :src="ossFileUrls[value]" alt="file" class="img-fluid restricted-image" />
                      </div>
                      <div v-else>
                        <a :href="ossFileUrls[value]" download>下载文件</a>
                      </div>
                    </div>
                    <div v-else>
                      {{ value }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>         
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <soft-button color="warning" variant="gradient" @click="markPhoneAuthorized" :disabled="markingAuth">
            {{ markingAuth ? '处理中...' : '已通过手机授权' }}
          </soft-button>
          <soft-button color="secondary" @click="handleDocDownload(submission)">打包下载文件</soft-button>
          <soft-button @click="close">关闭</soft-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftButton from "@/components/SoftButton.vue";
import { getOSSFileUrl } from '@/api/img'
import { getMerchPayInfosDownload, updateSubmissionStatus } from '@/api/merch'
import img1 from "../../assets/img/file.jpeg";
import { nextTick } from 'vue';

export default {
  name: "SubmissionDetials",
  data() {
    return {
      img1,
      modalStyle: {
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "absolute",
        maxWidth: "800px",
        width: "100%",
      },
      parsedPayInfo: null,  // Store the parsed pay_info object
      ossFileUrls: {}, // Store OSS file URLs
      markingAuth: false, // "已通过手机授权" 按钮 loading 状态
      title: {
        'id_photo': '身份证照',
        'storefront_photo': '门头照',
        'machine_photo': '设备及室内照',
        'bank_card_photo': '银行卡照或公户照',
        'bank_account_info': '银行信息',
        'store_address': '店铺地址',
        'business_license': '营业执照',
        'merchant_type': '商户类型',
        'bank_name': '开户银行',
        'account_number': '银行账号',
        'account_holder': '户名',
        'branch': '开户网点',
        'front':'身份证人像面',
        'back':'身份证国徽面',
        'supplementary_files': '附加资料',
      },
    };
  },
  components: {
    SoftButton,
    SoftAvatar,
  },
  props: {
    submission: {
      type: Object,
      required: true,
    }
  },
  computed: {
    // 判断是否为个人小微商户
    isIndividualMerchant() {
      return this.parsedPayInfo && this.parsedPayInfo.merchant_type === 'individual'
    },
    // 商户类型标签（企业商户 / 个人小微商户）
    merchantTypeLabel() {
      if (!this.parsedPayInfo) return '企业商户'
      return this.parsedPayInfo.merchant_type === 'individual' ? '个人小微商户' : '企业商户'
    },
    // 过滤 pay_info：小微商户跳过业务执照、商户类型字段不在此展示
    filteredPayInfo() {
      if (!this.parsedPayInfo) return {}
      // 跳过 merchant_type 字段（已在标题栏展示）
      const result = {}
      for (const key in this.parsedPayInfo) {
        if (key === 'merchant_type') continue
        result[key] = this.parsedPayInfo[key]
      }
      return result
    }
  },
  methods: {
    close() {
      this.$emit("close");  // Emit a close event to the parent
    },

    // Method to update modal position dynamically
    updateModalPosition() {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      this.modalStyle.left = `${windowWidth / 2}px`;
      this.modalStyle.top = `${windowHeight / 2}px`;
    },

    // Parse the pay_info string to JSON
    parsePayInfo() {
      try {
        console.log("payinfo:", this.submission.pay_info)
        return JSON.parse(this.submission.pay_info);
      } catch (e) {
        console.error("Failed to parse pay_info:", e);
        return null;
      }
    },

    // Check if a value is an object or array (recursive)
    isJson(value) {
      return typeof value === 'object' && value !== null;
    },

    // Check if value is an OSS object name
    isOSSFile(value) {
      return typeof value === 'string' && (value.includes('.') || value.includes('/')) && value.length > 1
    },

    // Check if OSS file is an image (basic check by file extension)
    isImage(value) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
      return imageExtensions.some(ext => value.endsWith(ext));
    },

    // Asynchronously get the OSS file URL and store it in the ossFileUrls object
    async fetchOSSFileUrls() {
      const fetchUrlForValue = async (value) => {
        if (this.isOSSFile(value) && !this.ossFileUrls[value]) {
          try {
            const url = await getOSSFileUrl(value);
            this.ossFileUrls[value] = url
            await nextTick()
          } catch (error) {
            console.error("Error fetching OSS file URL:", error);
          }
        }
      };

      // Fetch URLs for all OSS files
      for (const key in this.parsedPayInfo) {
        const value = this.parsedPayInfo[key];
        if (this.isJson(value)) {
          for (const nestedKey in value) {
            fetchUrlForValue(value[nestedKey]);
          }
        } else {
          fetchUrlForValue(value);
        }
      }
    },

    async handleDocDownload(row) {
      console.log(`handle doc download..row:`, row)
      try {
        const response = await getMerchPayInfosDownload({
          info_id: row.info_id,
          deliver_id: row.deliver_id
        })
        if (response.code === 0) {
          console.log('get download url:', response.desc)
          window.location.href = response.desc
          return
        } else {
          alert('获取打包文件地址失败:' + response.desc)
          return
        }
      } catch (error) {
        alert('请求失败:' + error)
      }
    },

    // 标记商户已完成手机授权
    async markPhoneAuthorized() {
      if (!confirm('确认此商户已通过手机完成收钱吧短信授权？\n\n点击确定后，进件状态将保持"处理中"，并备注"已通过手机授权"。')) return
      this.markingAuth = true
      try {
        const resp = await updateSubmissionStatus({
          info_id: this.submission.info_id,
          status: 'handling', // 保持处理中状态
          remark: '已通过手机授权'
        })
        if (resp.code === 0) {
          alert('已标记为：已通过手机授权')
          this.$emit('close') // 关闭弹窗，父组件会刷新列表
        } else {
          alert('操作失败：' + (resp.desc || '未知错误'))
        }
      } catch (error) {
        console.error('markPhoneAuthorized error:', error)
        alert('请求失败:' + error)
      } finally {
        this.markingAuth = false
      }
    },

  },

  mounted() {
    // Parse the pay_info string when the component is mounted
    this.parsedPayInfo = this.parsePayInfo();

    // Fetch URLs for OSS files
    this.fetchOSSFileUrls();

    // Update the modal position when component is mounted
    this.updateModalPosition();

    // Optionally, update the position on window resize
    window.addEventListener('resize', this.updateModalPosition);
  },

  beforeUnmount() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateModalPosition);
  }
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}

.modal-dialog {
  position: absolute;
  max-width: 800px;
  width: 100%;
}

.modal-content {
  background-color: white;
  border-radius: 4px;
}

.modal-header {
  background-color: #f8f9fa;
}

.modal-body {
  padding: 1rem;
}

.modal-footer {
  padding: 0.75rem;
  text-align: right;
}
.restricted-image {
  width: 100px;
  height: 100px;
  object-fit: cover; /* Makes sure the image fills the box and maintains aspect ratio */
}
</style>
